<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.form.get('id').value">Ajouter une condition de réglement</h3>
      <h3 *ngIf="this.form.get('id').value">Modifier une condition de réglement</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">

        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" formControlName="code" maxlength="7" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" maxlength="30" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label >mode </mat-label> 
            <input matInput name="mode" id="mode" 
            formControlName="mode" maxlength="7"  required>
            <span class="fa fa-info-circle errspan" matTooltip="(X.Y.Z, X=0 pas de fin de mois, X=1 = Fin de mois, Y = Ajout de Y jours, Z = 0 Pas de fin de mois après l'ajout Y, Z=1 Fin de mois après l'ajout Y)"></span>
            <mat-error *ngIf="form.get('mode').hasError('required')">
                Veuillez saisir un mode
            </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>code NTH</mat-label>
            <input matInput name="codeNTH" formControlName="codeNTH" maxlength="7">
            </mat-form-field>
        </div>

    </form>
  </div>
  
  <div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
  </div>

